// Post-login landing for the Auth0 redirect flow.
//
// Auth0 always returns on `/?code=…&state=…` (redirect_uri = origin); the deep link the user
// originally asked for travels in appState.returnTo (posé par Login/AccessGate). The old handler
// called window.history.replaceState : the NATIVE API : which connected-react-router never sees:
// the router stayed on "/", Login kept rendering and its own effect then clobbered the URL with
// /dashboard, losing the deep link. Navigating through the ROUTER history (the same instance
// ConnectedRouter mounts) makes the app actually land on the deep link, query string included.
import type { AppState } from "@auth0/auth0-react";
import { history } from "../Redux/Index";

/** Where to land after the Auth0 redirect: the preserved deep link, else the dashboard. */
export function resolvePostLoginTarget(appState?: AppState): string {
	const returnTo = appState?.returnTo;
	if (typeof returnTo === "string" && returnTo.length > 0 && returnTo !== "/") {
		return returnTo;
	}
	return "/dashboard";
}

/** Auth0Provider onRedirectCallback : replaces the /?code&state URL via the ROUTER history. */
export function onRedirectCallback(appState?: AppState): void {
	history.replace(resolvePostLoginTarget(appState));
}
